import React, { Component } from 'react';
import { get, isEmpty, flow } from 'lodash';
import cns from 'classnames';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import Image from '../../shared/components/Image';

const Types = {
    CARD: 'card'
};

const cardSource = {
    beginDrag(props) {
        return {
            id: props.categoryId,
            index: props.currentIndex
        };
    },
    canDrag(props) {
        return props.canDrag;
    }
};

const cardTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.currentIndex;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        props.moveCard(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};

class DragCategoryResult extends Component {
    static propTypes = {
        className: PropTypes.string,
        categoryId: PropTypes.string,
        canDrop: PropTypes.bool,
        isOver: PropTypes.bool,
        categoryLookup: PropTypes.object,
        connectDragSource: PropTypes.any,
        connectDropTarget: PropTypes.any
    };

    render() {
        const { isOver, canDrop, categoryLookup, categoryId, connectDragSource, connectDropTarget, className } =
            this.props;

        const category = get(categoryLookup, `[${categoryId}]`, {});

        // returns null if category is an empty object
        if (isEmpty(category)) {
            return null;
        }

        return connectDragSource(
            connectDropTarget(
                <div
                    key={categoryId}
                    className={cns(
                        'row',
                        'dragCategoryResultItem',
                        'dragCategoryResultItemTop',
                        { dragCategoryResultCanDrop: isOver && canDrop },
                        className
                    )}
                >
                    <div className={'col-4 col-sm-2'}>
                        <Image
                            className={'dragCategoryResultImage'}
                            src={category.image}
                            dimension={{ w: 70, h: 70 }}
                            alt={category.name}
                        />
                    </div>
                    <div className={'col-8 col-sm-10 dragCategoryResultContainer'}>
                        <div className={'dragCategoryResultTitle'}>{category.name}</div>
                        <div className={'dragCategoryResultDescription'}>{category.description}</div>
                    </div>
                </div>
            )
        );
    }
}

export default flow(
    DropTarget(Types.CARD, cardTarget, (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop()
    })),
    DragSource(Types.CARD, cardSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    }))
)(DragCategoryResult);
